var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["modal/user/login/header.j2"] = require( "modal/user/login/header.j2" );
dependencies["modal/user/login/form-fields.j2"] = require( "modal/user/login/form-fields.j2" );
dependencies["modal/user/login/forgot-password-link.j2"] = require( "modal/user/login/forgot-password-link.j2" );
dependencies["modal/user/login/form-buttons.j2"] = require( "modal/user/login/form-buttons.j2" );
dependencies["modal/user/login/create-account-button.j2"] = require( "modal/user/login/create-account-button.j2" );
dependencies["modal/user/login/signup-link.j2"] = require( "modal/user/login/signup-link.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/login/modal-login-contents.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("hasErrors")) {
var t_6 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_6);
if(t_1.hasOwnProperty("validatedField")) {
var t_7 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_7);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("signUpUrl")) {
var t_11 = t_8.signUpUrl;
} else {
cb(new Error("cannot import 'signUpUrl'")); return;
}
context.setVariable("signUpUrl", t_11);
if(t_8.hasOwnProperty("loginUrl")) {
var t_12 = t_8.loginUrl;
} else {
cb(new Error("cannot import 'loginUrl'")); return;
}
context.setVariable("loginUrl", t_12);
output += "\n\n\n";
if(runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "\n\n<form novalidate class=\"js-login-form ";
output += runtime.suppressValue((lineno = 7, colno = 48, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\">\n\n    <div class=\"s-user-auth-standalone u-clearfix\" data-qa-auth-standalone>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-small--8 o-small--offset-2 o-large--5 o-large--offset-1 o-extra-large--4 o-extra-large--offset-2 c-modal-login__section-1\" data-qa-standalone-login>\n\n                ";
env.getTemplate("modal/user/login/header.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n                ";
env.getTemplate("modal/user/login/form-fields.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                ";
env.getTemplate("modal/user/login/forgot-password-link.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n                ";
env.getTemplate("modal/user/login/form-buttons.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n            </div>\n\n            <div class=\"o-column o-extra-small--12 o-small--8 o-small--offset-2 o-large--5 o-extra-large--4 c-modal-login__section-2\" data-qa-standalone-create>\n\n                <h2 class=\"c-modal-login__secondary-heading\">\n                    ";
output += runtime.suppressValue((lineno = 28, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_join-heading",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </h2>\n\n                ";
env.getTemplate("modal/user/login/create-account-button.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n</form>\n\n";
})})})})})})})})})});
}
else {
output += "\n\n<form novalidate class=\"js-login-form ";
output += runtime.suppressValue((lineno = 43, colno = 48, runtime.callWrap(t_6, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"messages")),"generalErrors")])), env.opts.autoescape);
output += "\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-parsley-validate>\n\n    <div class=\"c-modal-login\" data-qa-modal-signin>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <div class=\" c-modal-login__text\">\n\n                    ";
env.getTemplate("modal/user/login/header.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
t_33.render(context.getVariables(), frame, function(t_36,t_34) {
if(t_36) { cb(t_36); return; }
output += t_34
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                    ";
env.getTemplate("modal/user/login/form-fields.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
t_37.render(context.getVariables(), frame, function(t_40,t_38) {
if(t_40) { cb(t_40); return; }
output += t_38
output += "\n\n                    ";
env.getTemplate("modal/user/login/forgot-password-link.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_41.render(context.getVariables(), frame, function(t_44,t_42) {
if(t_44) { cb(t_44); return; }
output += t_42
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 c-modal-login__buttons u-clearfix\">\n\n                ";
env.getTemplate("modal/user/login/form-buttons.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_47,t_45) {
if(t_47) { cb(t_47); return; }
t_45.render(context.getVariables(), frame, function(t_48,t_46) {
if(t_48) { cb(t_48); return; }
output += t_46
output += "\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <h2 class=\"c-modal-login__secondary-heading\">\n                    ";
output += runtime.suppressValue((lineno = 88, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_join-heading",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </h2>\n\n                ";
env.getTemplate("modal/user/login/signup-link.j2", false, "core/templates/modal/user/login/modal-login-contents.j2", null, function(t_51,t_49) {
if(t_51) { cb(t_51); return; }
t_49.render(context.getVariables(), frame, function(t_52,t_50) {
if(t_52) { cb(t_52); return; }
output += t_50
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n</form>\n\n";
})})})})})})})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/login/modal-login-contents.j2"] , dependencies)